import Dashboard from "./Dashboard";
import EmptyWithTitle from "./EmptyWithTitle";

export {
    Dashboard,
    EmptyWithTitle
};
